/* Aslan · Página de mayoreo (templates/page.mayoreo.json).
   Lógica del prototipo aprobado (referencias-mayoreo/prototipo) con datos reales de Shopify.
   Datos: sections/mayoreo-catalogo.liquid. Cada variante trae precio de mayoreo y de menudeo (para mostrar la ganancia).
   El carrito se guarda por id de variante: { variantId: cantidad }.
   Collar de piedra con dije: la llave es «idCollar+idDije» y cuenta como 1 pieza. */
(function () {
  'use strict';

  var root = document.getElementById('aslan-mayoreo');
  if (!root) return;

  /* ---------- Datos ---------- */
  function readJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var WA_NUMBER = (root.dataset.wa || '527621072158').replace(/\D/g, '');
  var LOGO = root.dataset.logo || '';
  var TYPES = readJSON(document.getElementById('aslan-mayoreo-tipos')) || [];
  var MOTIVOS = readJSON(document.getElementById('aslan-mayoreo-motivos')) || [];
  var PRODUCTS = [];
  var BY_ID = {};
  var VARS = {}; /* variantId → { p, label, price, ret, vi } */
  var BY_H = {};  /* handle → producto */
  function listAttr(k) { return (root.dataset[k] || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  var TOPS = listAttr('top'), DIJES = listAttr('dijes');
  var SURTIDO = listAttr('surtido').map(function (x) { var a = x.split(':'); return { h: a[0], q: parseInt(a[1], 10) || 1 }; });
  var AHORRO_DIJE = 100; /* En menudeo, collar + dije lleva −$100: así se calcula el precio en tienda del conjunto */

  function imgW(url, w) {
    if (!url) return '';
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + w) : url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function addItems(items) {
    items.forEach(function (it) {
      var id = String(it.id);
      if (BY_ID[id]) return;
      var p = {
        id: id, h: it.h, s: it.s || '', cd: !!it.cd, dj: it.dj || '', dv: String(it.dv || ''),
        n: it.n, t: it.t, t2: it.t2 || '', m: it.m || '', imgs: it.img || [],
        /* «@@» marca fin de párrafo / renglón en la descripción */
        d: (it.d || '').split('@@').map(function (s) { return s.trim(); }).filter(Boolean).join('\n'),
        v: it.v.map(function (x) { return { vid: String(x[0]), label: x[1], price: x[2] / 100, ret: (x[3] || 0) / 100 }; })
      };
      /* Una sola variante = pieza única: sin medida en pedido ni en el mensaje (brief §5) */
      if (p.v.length === 1) p.v[0].label = 'Única';
      p.img = p.imgs[0] || '';
      p.v.forEach(function (v, i) { VARS[v.vid] = { p: p, label: v.label, price: v.price, ret: v.ret, vi: i }; });
      PRODUCTS.push(p);
      BY_ID[id] = p;
      BY_H[p.h] = p;
    });
    /* Popularidad: primero lo más vendido (ajuste «Lo más pedido»); después, el orden de la colección */
    PRODUCTS.forEach(function (p, i) { p.top = PRODUCTS.length - i; });
    TOPS.forEach(function (h, i) { if (BY_H[h]) BY_H[h].top = PRODUCTS.length + TOPS.length - i; });
  }
  var first = readJSON(root.querySelector('.aslan-mayoreo-data')) || { page: 1, pages: 1, items: [] };
  addItems(first.items);

  /* Páginas 2..N: misma sección vía Section Rendering API */
  function loadRest() {
    var pages = [];
    for (var n = 2; n <= first.pages; n++) pages.push(n);
    if (!pages.length) return;
    var base = location.pathname + location.search + (location.search ? '&' : '?') + 'section_id=' + encodeURIComponent(root.dataset.section);
    Promise.all(pages.map(function (n) {
      return fetch(base + '&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var d = readJSON(doc.querySelector('.aslan-mayoreo-data') || { textContent: '' });
          return d ? d.items : [];
        })
        .catch(function () { return []; });
    })).then(function (lists) {
      lists.forEach(addItems);
      set({ loading: false }, true);
    });
  }

  var BIZ = [
    { k: 'regalos', n: 'Tienda de regalos', mix: { pro: .4, vin: .3, fe: .3 } },
    { k: 'boutique', n: 'Boutique', mix: { pro: .4, vin: .4, mem: .2 } },
    { k: 'religiosos', n: 'Artículos religiosos', mix: { fe: .7, pro: .3 } },
    { k: 'catalogo', n: 'Venta por catálogo', mix: {} }
  ];

  /* ---------- Reglas de negocio (brief §4) ---------- */
  var MIN = 3000;
  /* Mínimo de surtido (decisión del 8-oct-2026): además de $3,000, al menos N piezas.
     Un pack o juego cuenta como 1 pieza. Editable en la sección («Piezas mínimas»). */
  var MIN_PZ = parseInt(root.dataset.minPz, 10) || 12;
  /* Precio único. Sin descuentos por volumen; solo promoción de temporada (ajuste de la sección, máximo 5 %) */
  var PROMO = Math.min(5, Math.max(0, parseFloat(root.dataset.promo) || 0)) / 100;
  function discRate() { return PROMO; }
  function money(n) { return '$' + Math.round(n).toLocaleString('es-MX'); }
  function byId(id) { return BY_ID[id] || null; }
  function minPrice(p) { return Math.min.apply(null, p.v.map(function (x) { return x.price; })); }
  function multi(p) { return p.v.length > 1; }
  function ofType(p, k) { return p.t === k || p.t2 === k; }
  function motivoName(k) { var m = MOTIVOS.filter(function (x) { return x.k === k; })[0]; return m ? m.n : ''; }
  function typeName(k) { var t = TYPES.filter(function (x) { return x.k === k; })[0]; return t ? t.n : ''; }
  /* Lo que falta para el mínimo (dinero y/o piezas) */
  function falta(sub, count) { return { d: Math.max(0, MIN - sub), p: Math.max(0, MIN_PZ - count) }; }
  function piezas(n) { return n + (n === 1 ? ' pieza' : ' piezas'); }
  function faltaTxt(f) {
    var verbo = (!f.d && f.p === 1) ? 'Falta ' : 'Faltan ';
    return verbo + [f.d ? money(f.d) : '', f.p ? piezas(f.p) : ''].filter(Boolean).join(' y ');
  }
  function nextStep(sub, count) {
    var f = falta(sub, count || 0);
    if (f.d || f.p) {
      /* La barra avanza según lo que más falte (dinero o piezas) */
      return { pct: Math.round(100 * Math.min(1, sub / MIN, (count || 0) / MIN_PZ)), txt: faltaTxt(f) + ' para el mínimo' };
    }
    return { pct: 100, txt: 'Ya cumples el pedido mínimo' };
  }

  /* ---------- Armador por presupuesto (brief §3.6) ---------- */
  function depthOf(price) { return price <= 200 ? 6 : price <= 350 ? 4 : 2; }
  /* Cómo se reparte una pieza entre sus variantes:
     'juego'  → todo al juego completo (variante «Juego…»)
     'medida' → cm / mm / tallas / números: las del centro pesan el doble
     'parejo' → colores u otras opciones: reparto igual */
  /* 16 cm · 45cm · Talla 7 · #7 · 7 · «6.5 / Blanca» (talla + color) */
  var RE_MEDIDA = /(\d+(\.\d+)?\s*(cm|mm)\b)|talla|^\s*#\s*\d+(\.\d+)?\s*$|^\s*\d+(\.\d+)?\s*(\/.*)?$/i;
  function splitMode(p) {
    if (p.v.length === 1) return 'unica';
    if (p.v.some(function (v) { return /^juego/i.test(v.label); })) return 'juego';
    if (p.v.every(function (v) { return RE_MEDIDA.test(v.label); })) return 'medida';
    return 'parejo';
  }
  function juegoVar(p) { return p.v.filter(function (v) { return /^juego/i.test(v.label); })[0] || p.v[0]; }
  /* Precio de referencia de la pieza en la sugerencia */
  function unitPrice(p) { return splitMode(p) === 'juego' ? juegoVar(p).price : minPrice(p); }
  /* Reparte qty entre variantes → [{ v, q }]. Ej.: 6 pulseras 16/18/20 cm → 2 · 3 · 1; 5 collares 40/45 → 3 · 2 */
  function splitQty(p, qty) {
    var mode = splitMode(p);
    if (mode === 'unica') return [{ v: p.v[0], q: qty }];
    if (mode === 'juego') return [{ v: juegoVar(p), q: qty }];
    var n = p.v.length;
    var w = p.v.map(function (_, i) { return (mode === 'medida' && n >= 3 && i > 0 && i < n - 1) ? 2 : 1; });
    var W = w.reduce(function (a, b) { return a + b; }, 0);
    var raw = w.map(function (x) { return qty * x / W; });
    var out = raw.map(Math.floor), left = qty - out.reduce(function (a, b) { return a + b; }, 0);
    raw.map(function (r, i) { return { i: i, f: r - Math.floor(r) }; })
      .sort(function (a, b) { return b.f - a.f || a.i - b.i; })
      .slice(0, left).forEach(function (x) { out[x.i]++; });
    return p.v.map(function (v, i) { return { v: v, q: out[i] }; }).filter(function (x) { return x.q > 0; });
  }
  function splitTotal(p, qty) { return splitQty(p, qty).reduce(function (a, x) { return a + x.v.price * x.q; }, 0); }
  function buildSugg(budget, bizKey) {
    var biz = BIZ.filter(function (b) { return b.k === bizKey; })[0] || BIZ[0];
    var maxTop = PRODUCTS.length || 1;
    var cands = PRODUCTS.filter(function (p) { return !p.cd; }).map(function (p) {
      var s = p.top / maxTop, mp = unitPrice(p);
      s = bizKey === 'catalogo' ? s * (mp <= 250 ? 1.5 : .7) : s * (1 + 2 * (biz.mix[p.m] || 0));
      return { p: p, s: s, price: mp };
    }).sort(function (a, b) { return b.s - a.s; });
    var lines = {}, order = [], total = 0, cap = budget * .25, ceil = budget * 1.05;
    for (var r = 0; r < 12 && total < budget; r++) {
      for (var i = 0; i < cands.length && total < budget; i++) {
        var c = cands[i], cur = lines[c.p.id] || 0, add = depthOf(c.price);
        if ((cur + add) * c.price > cap) add = Math.floor((cap - cur * c.price) / c.price);
        if (total + add * c.price > ceil) add = Math.floor((ceil - total) / c.price);
        if (add <= 0) continue;
        if (!cur) order.push(c.p.id);
        lines[c.p.id] = cur + add; total += add * c.price;
      }
    }
    var cheap = cands.slice().sort(function (a, b) { return a.price - b.price; }), g = 0;
    while (total < budget && g < 200 && cheap.length) {
      var cc = cheap[g % Math.min(3, cheap.length)];
      if (!lines[cc.p.id]) order.push(cc.p.id);
      lines[cc.p.id] = (lines[cc.p.id] || 0) + 1; total += cc.price; g++;
    }
    /* Mínimo de piezas: si faltan, completa con las piezas más económicas */
    var pcs = order.reduce(function (a, id) { return a + lines[id]; }, 0), h = 0;
    while (pcs < MIN_PZ && h < 100 && cheap.length) {
      var ch = cheap[h % Math.min(3, cheap.length)];
      if (!lines[ch.p.id]) order.push(ch.p.id);
      lines[ch.p.id] = (lines[ch.p.id] || 0) + 1; pcs++; h++;
    }
    return order.map(function (id) { return { id: id, qty: lines[id] }; });
  }

  /* ---------- Almacenamiento local (llaves del prototipo + carrito en curso) ---------- */
  function load(k) { try { var r = localStorage.getItem(k); return r ? JSON.parse(r) : null; } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  var K_ULTIMO = 'aslan_mayoreo_ultimo', K_ENVIO = 'aslan_mayoreo_envio', K_CORREO = 'aslan_mayoreo_correo';
  var K_CARRITO = 'aslan_mayoreo_carrito'; /* pedido en curso: sobrevive a recargar la página */

  /* ---------- Estado ---------- */
  var S = {
    screen: 'home', type: 'pul', motivo: '', detail: '', img: 0, back: 'cat',
    cart: load(K_CARRITO) || {},
    email: (load(K_CORREO) || {}).email || '', optIn: true,
    ship: load(K_ENVIO) || { nombre: '', tel: '', cp: '', colonia: '', calle: '' },
    shipEdit: !load(K_ENVIO), last: load(K_ULTIMO),
    budget: 6000, biz: 'regalos', sugg: null, swap: '', sent: false, dj: {}, sk: 1, simb: '',
    loading: first.pages > 1
  };
  function set(patch, keepScroll, fromHistory) {
    var sc = root.querySelector('.scroll'), top = sc ? sc.scrollTop : 0, prev = S.screen;
    var prevState = { screen: S.screen, type: S.type, motivo: S.motivo, simb: S.simb, detail: S.detail, back: S.back };
    Object.assign(S, patch);
    if ('cart' in patch) save(K_CARRITO, S.cart);
    if (!fromHistory && S.screen !== prev) {
      try { history.pushState({ am: { screen: S.screen, type: S.type, motivo: S.motivo, simb: S.simb, detail: S.detail, back: S.back } }, ''); } catch (e) {}
    }
    render();
    var sc2 = root.querySelector('.scroll');
    if (sc2) sc2.scrollTop = (keepScroll || prev === S.screen) ? top : 0;
    return prevState;
  }
  function addQty(vid, d) {
    var c = Object.assign({}, S.cart), q = (c[vid] || 0) + d;
    if (q <= 0) delete c[vid]; else c[vid] = q;
    set({ cart: c, sent: false }, true);
  }
  function cartLines() {
    return Object.keys(S.cart).filter(keyOk).map(function (k) {
      var a = k.split('+'), v = VARS[a[0]], d = a[1] ? VARS[a[1]] : null, qty = S.cart[k], pr = v.price + (d ? d.price : 0);
      return { key: k, p: v.p, variant: v.label, qty: qty, price: pr, cprice: v.price, total: qty * pr, vi: v.vi, dije: d,
        ret: (v.ret + (d ? d.ret - AHORRO_DIJE : 0)) * qty };
    });
  }
  function orderLines(lines) {
    var firstIdx = {};
    lines.forEach(function (l, i) { if (!(l.p.id in firstIdx)) firstIdx[l.p.id] = i; });
    lines.sort(function (a, b) { return firstIdx[a.p.id] - firstIdx[b.p.id] || a.vi - b.vi; });
    lines.forEach(function (l, i) { l.last = !lines[i + 1] || lines[i + 1].p.id !== l.p.id; });
    return lines;
  }
  function totals(lines) {
    var count = lines.reduce(function (a, l) { return a + l.qty; }, 0), sub = lines.reduce(function (a, l) { return a + l.total; }, 0);
    var rate = discRate(sub), disc = sub * rate;
    return { count: count, sub: sub, rate: rate, disc: disc, total: sub - disc };
  }
  function qtyOfProduct(p) {
    return Object.keys(S.cart).reduce(function (a, k) { var v = VARS[k.split('+')[0]]; return a + (v && v.p === p ? S.cart[k] : 0); }, 0);
  }
  /* ---------- Collar de piedra + dije ---------- */
  function keyOk(k) { var a = k.split('+'); return !!VARS[a[0]] && (!a[1] || !!VARS[a[1]]); }
  function dijeOpts() { return DIJES.map(function (h) { return BY_H[h]; }).filter(Boolean); }
  function ownDije(p) {
    var d = BY_H[p.dj] || dijeOpts()[0];
    if (!d) return '';
    return (d.v.filter(function (x) { return x.vid === p.dv; })[0] || d.v[0]).vid;
  }
  function curDije(p) { var sel = S.dj[p.id]; return sel && VARS[sel] ? sel : ownDije(p); }
  function conDije(p) { return p.cd && !!curDije(p); }
  function dijeName(v) { return v.p.n + (v.label === 'Única' ? '' : ' (' + v.label + ')'); }
  function cheapest(p) { return p.v.slice().sort(function (a, b) { return a.price - b.price; })[0]; }
  /* Precio de la tarjeta: la variante más económica; en collares, con el dije de la foto */
  function cardPrice(p) {
    var c = cheapest(p), d = conDije(p) ? VARS[ownDije(p)] : null;
    return d ? { may: c.price + d.price, ret: c.ret + d.ret - AHORRO_DIJE } : { may: c.price, ret: c.ret };
  }
  function ganaTxt(cp) {
    return cp.ret > cp.may ? '<div class="venta">Se vende en ' + money(cp.ret) + '</div><div class="gana">Ganas ' + money(cp.ret - cp.may) + '</div>' : '';
  }
  /* ---------- Primer surtido ---------- */
  function baseVar(p) {
    var e = p.v.filter(function (v) { return /est[aá]ndar/i.test(v.label); })[0];
    if (e) return e;
    /* Entre las más económicas, la medida de en medio (15 · 17 · 19 cm → 17 cm) */
    var c = cheapest(p).price, same = p.v.filter(function (v) { return v.price === c; });
    return same[Math.floor((same.length - 1) / 2)];
  }
  function surtido(k) {
    return SURTIDO.map(function (x) { var p = BY_H[x.h]; return p ? { p: p, v: baseVar(p), q: x.q * k } : null; }).filter(Boolean);
  }
  function surtidoTot(L) {
    return L.reduce(function (a, l) { a.pz += l.q; a.inv += l.v.price * l.q; a.val += l.v.ret * l.q; return a; }, { pz: 0, inv: 0, val: 0 });
  }

  /* ---------- Plantillas ---------- */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function symbol(m, extra) { return m ? '<span class="symbol ' + (extra || '') + '"><i class="diamond"></i>' + motivoName(m) + '</span>' : ''; }
  function price(n, cls) { return '<span class="price ' + (cls || '') + '"><b>' + money(n) + '</b><small>MXN</small></span>'; }
  function stepper(dec, inc, qty, cls) {
    return '<div class="stepper ' + (cls || '') + '"><button data-a="' + dec + '" aria-label="Quitar uno">−</button><span aria-live="polite">' + qty + '</span><button class="plus" data-a="' + inc + '" aria-label="Agregar uno">+</button></div>';
  }
  function photo(url, w, alt, eager) {
    return url ? '<img src="' + esc(imgW(url, w)) + '" alt="' + esc(alt) + '"' + (eager ? '' : ' loading="lazy" decoding="async"') + '>' : '';
  }
  function varLabel(label) { return label === 'Única' ? 'Pieza' : label; }

  function ann() { return '<div class="am-ann">Mayoreo · desde ' + MIN_PZ + ' piezas y ' + money(MIN) + ' · envío gratis</div>'; }
  function topbar(count) {
    return ann() + '<header class="topbar"><a href="/" aria-label="Ir a la tienda Aslan"><img class="logo" src="' + esc(LOGO) + '" alt="Aslan Joyería .925" width="65" height="26"></a>' +
      '<button class="cartbtn" data-a="go:cart">Mi pedido <span class="count">' + count + '</span></button></header>';
  }
  function bar(t) {
    if (!t.count) return '';
    var step = nextStep(t.sub, t.count), pct = step.pct;
    return '<div class="bar"><div class="track"><i style="width:' + pct + '%"></i></div><div class="row"><div><div class="amt">' + money(t.sub) + '</div>' +
      '<div class="sub">' + t.count + ' pz · ' + step.txt + '</div></div><button class="btn on-dark sm" data-a="go:cart">Ver mi pedido</button></div></div>';
  }

  /* Tarjeta de producto: la misma del home de menudeo, con precio de mayoreo y ganancia */
  function card(p) {
    var q = qtyOfProduct(p), cp = cardPrice(p), mp = cheapest(p).price, cd = conDije(p);
    var varies = cd || p.v.some(function (x) { return x.price !== mp; }), vid = p.v[0].vid, needs = multi(p) || cd;
    var act = (q > 0 && !needs) ? stepper('dec:' + vid, 'inc:' + vid, q)
      : '<button class="addc" data-a="' + (needs ? 'detail:' + p.id : 'inc:' + vid) + '" aria-label="' + (cd ? 'Elegir dije' : needs ? 'Elegir medida' : 'Agregar') + ' de ' + esc(p.n) + '">+</button>';
    return '<article class="pcard"><div class="photo" data-a="detail:' + p.id + '" aria-hidden="true">' + photo(p.img, 400, p.n) +
      (q ? '<span class="badge">' + q + ' pz</span>' : '') + ((q > 0 && !needs) ? '' : act) + '</div><div class="meta">' +
      '<div class="name" data-a="detail:' + p.id + '" role="button" tabindex="0">' + esc(p.n) + '</div>' +
      (cd ? '<div class="condije">Con dije · tú lo eliges</div>' : '') +
      '<div class="pr">' + (cd ? '<span>Como en la foto</span> ' : varies ? '<span>Desde</span> ' : '') + money(cp.may) + '</div>' + ganaTxt(cp) +
      ((q > 0 && !needs) ? act : '') + (q > 0 && needs ? '<button class="btn outline sm block" data-a="detail:' + p.id + '">' + q + ' pz · Ajustar</button>' : '') + '</div></article>';
  }
  function hero() {
    return '<section class="ghero"><div class="gtxt"><span class="geb">Mayoreo · Plata .925 de Taxco</span>' +
      '<h1 class="gt">Compras a ' + esc(root.dataset.gMay) + '. <em>Vendes a ' + esc(root.dataset.gRet) + '.</em></h1>' +
      '<p class="gs">Hecha a mano en Taxco, la misma pieza que se vende en nuestra tienda.</p>' +
      '<button class="gcta" data-a="cat:pul">Ver catálogo →</button></div>' +
      (root.dataset.gImg ? '<div class="gimg"><img src="' + esc(root.dataset.gImg) + '" alt="' + esc(root.dataset.gName || '') + '"></div>' : '') + '</section>';
  }
  function reglas() {
    return '<div class="reglas"><div><b>' + MIN_PZ + '</b>piezas mínimo</div><div><b>' + money(MIN) + '</b>pedido mínimo</div><div><b>Gratis</b>envío</div><div><b>5 días</b>hábiles aprox.</div></div>';
  }
  var SIMBOLOS = [['san-benito', 'San Benito'], ['ojo-turco', 'Ojo turco'], ['guadalupe', 'Guadalupe'], ['nudo-de-bruja', 'Nudo de bruja'], ['san-judas', 'San Judas'], ['mano-de-fatima', 'Mano de Fátima'], ['corazon', 'Corazones'], ['cruz', 'Cruz']];
  function simbName(k) { var x = SIMBOLOS.filter(function (y) { return y[0] === k; })[0]; return x ? x[1] : ''; }
  function byTop(a, b) { return b.top - a.top; }
  function surtidoBox() {
    var L = surtido(S.sk), base = surtidoTot(surtido(1));
    if (L.length !== SURTIDO.length || !L.length) return '<div class="empty">Cargando tu surtido…</div>';
    var T = surtidoTot(L), fotos = L.map(function (l) { return '<div class="tf">' + photo(l.p.img, 240, l.p.n) + '<b>' + l.q + ' pz</b><small>' + esc(l.p.n) + '</small></div>'; }).join('');
    var pills = [1, 2, 4].map(function (k) { return '<button class="' + (S.sk === k ? 'on' : '') + '" data-a="sk:' + k + '">' + money(base.inv * k) + '</button>'; }).join('');
    return '<div class="ticket"><div class="tleft"><div class="tfotos">' + fotos + '</div><p class="tnote">Medidas y colores los cambias en tu pedido.</p></div>' +
      '<div class="tright"><p class="tn">' + T.pz + ' piezas, lo más pedido</p><div class="pills">' + pills + '<button data-a="go:nuevo">Arma el tuyo</button></div>' +
      '<div class="tr"><span>Inviertes</span><b>' + money(T.inv) + '</b></div><div class="tr"><span>Valen en tienda</span><b>' + money(T.val) + '</b></div>' +
      '<div class="tr big"><span>Ganas</span><span>' + money(T.val - T.inv) + '</span></div>' +
      '<button class="btn lg block" data-a="usesurt">Usar este surtido</button></div></div>';
  }
  function vHome(t) {
    var last = S.last && S.last.cart && Object.keys(S.last.cart).length ? S.last : null;
    var tiles = TYPES.map(function (ty) {
      var list = PRODUCTS.filter(function (p) { return ofType(p, ty.k); }).sort(byTop);
      if (!list.length) return '';
      return '<button class="tile" data-a="cat:' + ty.k + '"><div class="photo">' + photo(list[0].img, 400, ty.n) + '</div>' +
        '<span class="n">' + ty.n + '<em>' + list.length + '</em></span></button>';
    }).join('');
    var circ = SIMBOLOS.map(function (x) {
      var p = PRODUCTS.filter(function (q) { return q.s === x[0]; }).sort(byTop)[0];
      return p ? '<button data-a="simb:' + x[0] + '">' + photo(p.img, 160, x[1]) + '<span>' + x[1] + '</span></button>' : '';
    }).join('');
    var top = PRODUCTS.slice().sort(byTop).slice(0, 8).map(card).join('');
    return topbar(t.count) + '<main class="scroll fade">' + hero() + reglas() +
      (last ? '<button class="repite" data-a="repeat"><span>Repetir mi último pedido</span><small>' + last.date + ' · ' + last.count + ' pz · ' + money(last.sub) + '</small></button>' : '') +
      '<section class="section sur"><h2 class="sh">Tu primer surtido</h2>' + surtidoBox() + '</section>' +
      '<section class="section"><h2 class="sh">Compra por significado</h2><div class="circ">' + circ + '</div></section>' +
      '<section class="section"><h2 class="sh">Lo más pedido</h2><div class="grid">' + top + '</div></section>' +
      '<section class="section"><h2 class="sh">Todo el catálogo</h2><div class="tiles">' + tiles + '</div></section>' +
      '<section class="section"><h2 class="sh">Cómo pedir</h2><ol class="pasos"><li><b>Elige</b> desde ' + MIN_PZ + ' piezas y ' + money(MIN) + '.</li><li><b>Envía</b> tu pedido por WhatsApp.</li><li><b>Paga</b> por transferencia y lo preparamos en 5 días hábiles aprox.</li></ol></section>' +
    '</main>' + bar(t);
  }

  function vCat(t) {
    var list = PRODUCTS.filter(function (p) {
      if (S.simb) return p.s === S.simb;
      if (S.type === 'all') return p.m === S.motivo;
      return ofType(p, S.type) && (!S.motivo || p.m === S.motivo);
    }).sort(byTop);
    var title = S.simb ? simbName(S.simb) : S.type === 'all' ? motivoName(S.motivo) : typeName(S.type);
    var tabs = TYPES.filter(function (ty) { return PRODUCTS.some(function (p) { return ofType(p, ty.k); }); })
      .map(function (ty) { return '<button class="tab ' + (ty.k === S.type ? 'on' : '') + '" data-a="tab:' + ty.k + '">' + ty.n + '</button>'; }).join('');
    var chips = '<button class="symbol all ' + (!S.motivo ? 'on' : '') + '" data-a="chip:">Todos</button>' +
      MOTIVOS.map(function (m) { return '<button class="symbol ' + (S.motivo === m.k ? 'on' : '') + '" data-a="chip:' + m.k + '"><i class="diamond"></i>' + m.n + '</button>'; }).join('');
    var cards = list.map(card).join('');
    return '<div class="cathead"><div class="row"><button class="iconbtn" data-a="go:home" aria-label="Inicio">←</button><h1 class="display">' + esc(title) + '</h1>' +
      '<button class="cartbtn" data-a="go:cart" aria-label="Mi pedido"><span class="count">' + t.count + '</span></button></div>' +
      (S.type === 'all' ? '' : '<nav class="tabs">' + tabs + '</nav>') + '</div>' +
      '<main class="scroll fade">' + (S.simb ? '' : '<div class="chips">' + chips + '</div>') + '<div class="count-line">' + list.length + ' piezas · precio por pieza</div>' +
      (list.length ? '<div class="grid">' + cards + '</div>' : '<div class="empty">' + (S.loading ? 'Cargando piezas…' : 'Todavía no hay piezas con este filtro.') + '</div>') + '</main>' + bar(t);
  }

  function vDetail() {
    var p = byId(S.detail);
    if (!p) return vHome(totals(cartLines()));
    var nSel = 0, totSel = 0, idx = Math.min(S.img, Math.max(0, p.imgs.length - 1));
    var cd = conDije(p), dv = cd ? curDije(p) : '', d = cd ? VARS[dv] : null;
    var rows = p.v.map(function (v) {
      var key = cd ? v.vid + '+' + dv : v.vid, q = S.cart[key] || 0, pr = v.price + (d ? d.price : 0);
      return '<div class="vrow"><div class="vl"><span>' + esc(varLabel(v.label)) + '</span><small>' + money(pr) + ' MXN c/u</small></div>' + stepper('dec:' + key, 'inc:' + key, q, 'soft') + '</div>';
    }).join('');
    cartLines().forEach(function (l) { if (l.p === p) { nSel += l.qty; totSel += l.total; } });
    var picker = '';
    if (cd) {
      var c0 = cheapest(p), sp = c0.price + d.price, sr = c0.ret + d.ret - AHORRO_DIJE;
      var opts = dijeOpts().map(function (x) {
        var on = x === d.p, pv = on ? d : cheapest(x);
        return '<button class="' + (on ? 'on' : '') + '" data-a="dj:' + p.id + ':' + pv.vid + '" aria-pressed="' + on + '">' + photo(x.img, 160, '') + '<span>' + esc(x.n.replace(/^(Dije|Medalla|Placa)\s+/, '')) + '</span><small>+' + money(pv.price) + '</small></button>';
      }).join('');
      var colores = d.p.v.length > 1 ? '<div class="djcol">' + d.p.v.map(function (v) {
        return '<button class="' + (v.vid === dv ? 'on' : '') + '" data-a="dj:' + p.id + ':' + v.vid + '">' + esc(v.label) + '</button>';
      }).join('') + '</div>' : '';
      var distinto = dv !== ownDije(p) ? '<p class="djnota">La foto muestra otro dije. El tuyo llega armado con ' + esc(dijeName(d)) + '.</p>' : '';
      picker = '<div class="label">Elige su dije</div><div class="djlist">' + opts + '</div>' + colores + distinto +
        '<div class="djsum"><div><span>Collar</span><span>' + money(c0.price) + '</span></div><div><span>' + esc(dijeName(d)) + '</span><span>' + money(d.price) + '</span></div>' +
        '<div class="tot"><span>Conjunto armado</span><span>' + money(sp) + '</span></div>' + ganaTxt({ may: sp, ret: sr }) + '</div>';
    }
    var thumbs = p.imgs.length > 1 ? '<div class="thumbs">' + p.imgs.map(function (u, i) {
      return '<button class="' + (i === idx ? 'on' : '') + '" data-a="img:' + i + '" aria-label="Foto ' + (i + 1) + '">' + photo(u, 160, '') + '</button>';
    }).join('') + '</div>' : '';
    return '<main class="scroll fade detail"><div class="photo">' + photo(p.imgs[idx], 800, p.n, true) +
      '<button class="iconbtn close" data-a="close" aria-label="Cerrar">✕</button></div>' + thumbs +
      '<div class="dbody"><div class="eyebrow">Plata .925 · Hecho en Taxco</div>' + (p.m ? '<div>' + symbol(p.m) + '</div>' : '') +
      '<h1 class="display">' + esc(p.n) + '</h1>' + (cd ? '' : '<div>' + price(minPrice(p), 'lg') + ' <span class="label" style="margin-left:6px">por pieza</span></div>' + ganaTxt(cardPrice(p))) +
      picker + '<div class="label">Cantidad por ' + (multi(p) ? 'medida' : 'pieza') + '</div>' + rows +
      /* En mayoreo el collar va con dije: se quita el texto de menudeo que dice que se vende solo */
      '<p>' + esc((p.d || 'Plata .925 con acabado artesanal. Incluye empaque de regalo y garantía de 1 año.').split(/El collar se vende solo/i)[0].trim()) + '</p></div></main>' +
      '<div class="dock"><button class="btn lg block" data-a="close">' + (nSel ? 'Listo · ' + nSel + ' pz · ' + money(totSel) : 'Seguir viendo') + '</button></div>';
  }

  function shipOk() {
    var sh = S.ship;
    return !!(sh.nombre.trim() && /^\d{10}$/.test(sh.tel) && /^\d{5}$/.test(sh.cp) && sh.colonia.trim() && sh.calle.trim());
  }
  function emailOk() { return /.+@.+\..+/.test(S.email.trim()); }
  function sendButton(t, lines) {
    var missing = [];
    if (!emailOk()) missing.push('correo');
    if (!shipOk()) missing.push('datos de envío');
    var f = falta(t.sub, t.count);
    if (!f.d && !f.p && !missing.length) {
      return '<a class="btn lg block" data-a="send" target="_blank" rel="noopener" href="' + esc(waUrl(lines, t)) + '">Enviar pedido por WhatsApp</a>';
    }
    return '<button class="btn lg block disabled" disabled>' + (f.d && f.p ? faltaTxt(f) + ' para el mínimo'
      : f.d ? faltaTxt(f) + ' para el mínimo de ' + money(MIN)
      : f.p ? faltaTxt(f) + ' para el mínimo de ' + MIN_PZ
      : 'Completa: ' + missing.join(' y ')) + '</button>';
  }

  function vCart(t, lines) {
    var step = nextStep(t.sub, t.count), pct = step.pct, sh = S.ship;
    orderLines(lines);
    var ls = lines.map(function (l) {
      return '<div class="line">' + photo(l.p.img, 160, '') + '<div><div class="n">' + esc(l.p.n) + '</div>' +
        '<div class="v">' + (l.dije ? 'Armado con ' + esc(dijeName(l.dije)) + ' · ' : '') + (l.variant === 'Única' ? '' : esc(l.variant) + ' · ') + money(l.price) + ' c/u</div>' +
        '<div class="r">' + stepper('dec:' + l.key, 'inc:' + l.key, l.qty, 'soft') + '<b style="font:500 15px/1 var(--font-sans)">' + money(l.total) + '</b></div>' +
        (multi(l.p) && l.last ? '<button class="more" data-a="detail:' + l.p.id + '">Otra medida</button>' : '') + '</div></div>';
    }).join('');
    return '<main class="scroll fade"><div class="page">' +
      '<div class="pagehead"><button class="iconbtn" data-a="go:home" aria-label="Inicio">←</button><div><div class="eyebrow">Mayoreo</div><h1 class="display" style="margin-top:6px">Mi pedido</h1></div></div>' +
      '<div class="c2"><div class="cl">' + (lines.length ? ls : S.sent
        ? '<div class="empty">Enviamos tu pedido a WhatsApp.<br>Si no se abrió, usa «Repetir mi último pedido» en el inicio.</div>'
        : '<div class="empty">Tu pedido está vacío.<br>Agrega piezas desde el catálogo.</div>') + '</div><div class="cr">' +
      '<div class="nudge"><div class="track"><i style="width:' + pct + '%"></i></div><span>' + step.txt + '</span></div>' +
      '<div class="summary"><div class="r"><span>Subtotal · ' + t.count + ' pz</span><span>' + money(t.sub) + '</span></div>' +
        (t.rate ? '<div class="r ok"><span>Promoción de temporada −' + Math.round(t.rate * 100) + ' %</span><span>−' + money(t.disc) + '</span></div>' : '') +
        '<div class="divider metal"></div><div class="total"><span>Total</span><b>' + money(t.total) + '</b></div>' +
        (lines.length ? (function () { var val = lines.reduce(function (a, l) { return a + l.ret; }, 0); return val > t.total ? '<div class="r"><span>Valen en tienda</span><span>' + money(val) + '</span></div><div class="r gan"><span>Ganas</span><span>' + money(val - t.total) + '</span></div>' : ''; })() : '') + '</div>' +
      '<label class="field"><span>Correo electrónico</span><input id="am-email" data-f="email" type="email" value="' + esc(S.email) + '" autocomplete="email" placeholder="tucorreo@ejemplo.com"></label>' +
      '<label class="check"><input id="am-optin" type="checkbox" data-a="optin" ' + (S.optIn ? 'checked' : '') + ' aria-describedby="am-legal"> Quiero recibir novedades, el catálogo del mes y promociones de mayoreo.</label>' +
      '<p class="legal" id="am-legal">Aslan Joyería usa tus datos para preparar y enviar tu pedido. Las novedades son opcionales: desmarca la casilla o date de baja desde cualquier correo. <a href="' + esc(root.dataset.privacy || '/policies/privacy-policy') + '" target="_blank" rel="noopener">Aviso de privacidad</a></p>' +
      '<div class="eyebrow" style="margin-top:6px">Envío</div>' + shipBlock(sh) +
      sendButton(t, lines) +
      '<div class="note">Te confirmamos disponibilidad, fecha y pago por WhatsApp.</div>' +
    '</div></div></div></main>';
  }

  function shipBlock(sh) {
    if (!S.shipEdit && shipOk()) {
      return '<div class="saved"><div><b>' + esc(sh.nombre) + ' · ' + esc(sh.tel) + '</b><span>' + esc(sh.calle) + '</span><span>Col. ' + esc(sh.colonia) + ' · C.P. ' + esc(sh.cp) + '</span></div>' +
        '<button class="btn outline sm" data-a="editship">Cambiar</button></div>';
    }
    return '<div class="two"><label class="field"><span>Quién recibe</span><input id="am-nombre" data-f="nombre" value="' + esc(sh.nombre) + '" autocomplete="name" placeholder="Nombre y apellido"></label>' +
      '<label class="field"><span>Teléfono</span><input id="am-tel" data-f="tel" value="' + esc(sh.tel) + '" inputmode="numeric" autocomplete="tel-national" placeholder="10 dígitos"></label></div>' +
      '<div class="two cp"><label class="field"><span>C.P.</span><input id="am-cp" data-f="cp" value="' + esc(sh.cp) + '" inputmode="numeric" autocomplete="postal-code" placeholder="5 dígitos"></label>' +
      '<label class="field"><span>Colonia</span><input id="am-colonia" data-f="colonia" value="' + esc(sh.colonia) + '" placeholder="Tu colonia"></label></div>' +
      '<label class="field"><span>Calle y número</span><input id="am-calle" data-f="calle" value="' + esc(sh.calle) + '" autocomplete="street-address" placeholder="Ej. Av. Juárez 25, int. 3"></label>' +
      '<div class="note" style="text-align:left">Lo guardamos en este celular para tu próximo pedido.</div>';
  }

  /* Folio ASL-##### : el mismo en el mensaje de WhatsApp y en Klaviyo; se renueva al enviar */
  function folio() { if (!S.folio) S.folio = 'ASL-' + String(Date.now()).slice(-5); return S.folio; }

  /* ---------- Klaviyo (lista «Mayoristas» + evento «Pedido mayoreo enviado») ----------
     - Con la casilla de novedades marcada: suscripción por correo a la lista (consentimiento de marketing).
     - Siempre: evento con el pedido, para medir y segmentar (no suscribe a nadie).
     Usa la API pública de cliente de Klaviyo (llave pública, sin secretos en el tema). */
  var KL_KEY = root.dataset.klKey || '', KL_LIST = root.dataset.klList || '';
  function klPost(path, body) {
    if (!KL_KEY) return;
    try {
      fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KL_KEY), {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      }).catch(function () {});
    } catch (e) {}
  }
  /* Klaviyo y el Operador reciben collar y dije como dos renglones; «Armado» dice con qué va cada uno */
  function medida(label) { return label === 'Única' ? '' : label; }
  function flatLines(lines) {
    var out = [];
    lines.forEach(function (l) {
      if (!l.dije) { out.push({ Producto: l.p.n, Medida: medida(l.variant), Cantidad: l.qty, Importe: Math.round(l.total) }); return; }
      out.push({ Producto: l.p.n, Medida: medida(l.variant), Cantidad: l.qty, Importe: Math.round(l.cprice * l.qty), Armado: dijeName(l.dije) });
      out.push({ Producto: l.dije.p.n, Medida: medida(l.dije.label), Cantidad: l.qty, Importe: Math.round(l.dije.price * l.qty), Armado: l.p.n });
    });
    return out;
  }
  function klaviyoSend(lines, t, id) {
    var email = S.email.trim(), sh = S.ship, parts = sh.nombre.trim().split(/\s+/);
    var profile = { email: email, first_name: parts[0] || '', last_name: parts.slice(1).join(' '),
      phone_number: /^\d{10}$/.test(sh.tel) ? '+52' + sh.tel : undefined,
      location: { zip: sh.cp, country: 'Mexico' }, properties: { 'Tipo de cliente': 'Mayorista' } };
    klPost('events', { data: { type: 'event', attributes: {
      metric: { data: { type: 'metric', attributes: { name: 'Pedido mayoreo enviado' } } },
      profile: { data: { type: 'profile', attributes: profile } },
      value: Math.round(t.total), value_currency: 'MXN', unique_id: id,
      properties: { Folio: id, Subtotal: Math.round(t.sub), Descuento: Math.round(t.disc), Total: Math.round(t.total), Piezas: t.count,
        'Acepta novedades': !!S.optIn, Productos: flatLines(lines).map(function (l) { return l.Producto; }).filter(function (n, i, a) { return a.indexOf(n) === i; }),
        Lineas: flatLines(lines) }
    } } });
    if (S.optIn && KL_LIST) {
      klPost('subscriptions', { data: { type: 'subscription', attributes: {
        custom_source: 'Mayoreo · pedido por WhatsApp',
        /* La API de cliente marca el consentimiento de correo al suscribir a la lista */
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }, relationships: { list: { data: { type: 'list', id: KL_LIST } } } } });
    }
  }

  /* Mensaje de WhatsApp · formato exacto del brief §5 (sin emojis) */
  function waUrl(lines, t) {
    var id = folio(), sh = S.ship;
    var msg = ['PEDIDO MAYOREO ' + id,
      'Correo: ' + S.email.trim() + (S.optIn ? ' (acepta novedades)' : ' (sin novedades)'),
      'Envío: ' + sh.nombre.trim() + ' · Tel. ' + sh.tel, sh.calle.trim() + ', Col. ' + sh.colonia.trim() + ', C.P. ' + sh.cp, '']
      .concat(lines.map(function (l) { return l.qty + ' × ' + l.p.n + (l.variant !== 'Única' ? ' (' + l.variant + ')' : '') + (l.dije ? ' armado con ' + dijeName(l.dije) : '') + ' — ' + money(l.total); }))
      .concat(['', 'Subtotal: ' + money(t.sub) + ' · ' + t.count + ' pz'])
      .concat(t.rate ? ['Promoción de temporada −' + Math.round(t.rate * 100) + ' %: −' + money(t.disc)] : [])
        .concat(['TOTAL: ' + money(t.total)]).join('\n');
    return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);
  }

  /* Actualiza solo el botón de envío para no perder el foco del campo que se está escribiendo */
  function refreshSend() {
    var lines = orderLines(cartLines()), t = totals(lines), tmp = document.createElement('div');
    tmp.innerHTML = sendButton(t, lines);
    var cur = root.querySelector('.page .btn.lg.block');
    if (cur && tmp.firstChild) cur.replaceWith(tmp.firstChild);
  }

  /* Soy nueva · armador por presupuesto (brief §3.6) */
  function budgetFill(b) { return ((b - 3000) / 17000 * 100) + '%'; }
  function vNuevo() {
    if (!S.sugg) S.sugg = buildSugg(S.budget, S.biz);
    S.sugg = S.sugg.filter(function (l) { return byId(l.id); });
    var sugg = S.sugg;
    var sub = sugg.reduce(function (a, l) { return a + splitTotal(byId(l.id), l.qty); }, 0), rate = discRate(sub);
    var pzTot = sugg.reduce(function (a, l) { return a + l.qty; }, 0), fN = falta(sub, pzTot);
    var cards = sugg.map(function (l, i) {
      var p = byId(l.id), pr = unitPrice(p), sp = splitQty(p, l.qty);
      var sizes = splitMode(p) === 'medida' || splitMode(p) === 'parejo'
        ? '<div class="sizes">' + sp.map(function (x) { return '<span>' + esc(x.v.label) + ' <b>×' + x.q + '</b></span>'; }).join('') + '</div>' : '';
      return '<article class="scard"><div class="photo">' + photo(p.img, 400, '') + '<span class="badge">' + l.qty + ' pz</span></div>' +
        '<div class="name">' + esc(p.n) + '</div><div class="calc">' + money(pr) + ' c/u · <b>' + money(splitTotal(p, l.qty)) + '</b></div>' + sizes +
        stepper('sdec:' + i, 'sinc:' + i, l.qty) + '<button class="linkbtn" data-a="swap:' + i + '">Cambiar pieza</button></article>';
    }).join('');
    var tick = function (v) { return '<span style="left:' + ((v - 3000) / 17000 * 100) + '%">' + '$' + (v / 1000) + 'k' + '</span>'; };
    return '<div class="nhead"><div class="row"><button class="btn ghost sm" style="padding:0" data-a="go:home">← Inicio</button><span class="eyebrow">Tu primer pedido</span></div>' +
      '<div class="budget"><span>¿Cuánto quieres invertir?</span><b class="am-budget">' + money(S.budget) + '</b></div>' +
      '<input id="am-budget" type="range" min="3000" max="20000" step="500" value="' + S.budget + '" data-f="budget" style="--fill:' + budgetFill(S.budget) + '" aria-label="Presupuesto">' +
      '<div class="ticks">' + tick(3000) + tick(6000) + tick(12000) + tick(20000) + '</div>' +
      '<div class="biz">' + BIZ.map(function (b) { return '<button class="' + (b.k === S.biz ? 'on' : '') + '" data-a="biz:' + b.k + '">' + b.n + '</button>'; }).join('') + '</div></div>' +
      '<main class="scroll fade"><div class="suggest-intro"><div class="row"><h2 class="display">Te sugerimos <i>esto</i></h2><span class="label">' + sugg.length + ' piezas · ' + sugg.reduce(function (a, l) { return a + l.qty; }, 0) + ' pz</span></div>' +
      '<p>Es un punto de partida: sube o baja cantidades, cambia piezas o agrega otras. Tu total se ajusta solo.</p></div>' +
      '<div class="grid">' + cards + '<button class="addtile" data-a="swap:add"><span class="plus"><span>+</span></span>Agregar otra pieza</button></div></main>' +
      '<div class="bar"><div class="row"><div><div class="sub">Llevas ' + money(sub) + ' · ' + pzTot + ' pz' +
        (fN.d || fN.p ? ' · ' + faltaTxt(fN).toLowerCase() + ' para el mínimo' : rate ? ' · −' + Math.round(rate * 100) + ' % aplicado' : '') + '</div>' +
      '<div class="amt" style="margin-top:4px">' + money(sub * (1 - rate)) + '</div></div><button class="btn on-dark sm" data-a="usesugg">Usar este pedido</button></div></div>' +
      (S.swap !== '' ? vSwap(sugg) : '');
  }

  function vSwap(sugg) {
    var adding = S.swap === 'add', idx = adding ? -1 : parseInt(S.swap, 10), line = adding ? null : sugg[idx];
    var used = sugg.map(function (l) { return l.id; }), ref = line ? unitPrice(byId(line.id)) : 0;
    var alts = PRODUCTS.filter(function (p) { return used.indexOf(p.id) < 0 && !p.cd; })
      .sort(function (a, b) { return line ? Math.abs(unitPrice(a) - ref) - Math.abs(unitPrice(b) - ref) : b.top - a.top; }).slice(0, 6);
    var cards = alts.map(function (p) {
      var pr = unitPrice(p), dif = line ? (pr - ref) * line.qty : 0;
      return '<article class="scard"><div class="photo">' + photo(p.img, 400, '') + '</div><div class="name">' + esc(p.n) + '</div>' +
        '<div class="calc">' + money(pr) + ' c/u</div>' +
        (line ? (Math.round(dif) === 0 ? '<div class="diff">Mismo precio</div>'
          : '<div class="diff ' + (dif > 0 ? 'up' : 'down') + '">' + (dif > 0 ? '+' : '−') + money(Math.abs(dif)) + ' vs. la actual</div>') : '') +
        '<button class="btn outline sm block" data-a="pick:' + p.id + '">Elegir</button></article>';
    }).join('');
    var lp = line ? byId(line.id) : null;
    return '<div class="sheetwrap" data-a="closeswap"><div class="sheet" data-stop="1" role="dialog" aria-modal="true" aria-label="' + (adding ? 'Agregar pieza' : 'Cambiar pieza') + '"><span class="grab"></span>' +
      '<div style="display:flex;justify-content:space-between;align-items:center"><h2 class="display" style="font-size:26px">' + (adding ? 'Agregar pieza' : 'Cambiar pieza') + '</h2>' +
      '<button class="iconbtn" data-a="closeswap" aria-label="Cerrar">✕</button></div>' +
      (lp ? '<div class="from">' + photo(lp.img, 160, '') + '<div><span class="label">Estás cambiando</span><b>' + esc(lp.n) + '</b>' + line.qty + ' pz · ' + money(splitTotal(lp, line.qty)) + '</div></div>'
          : '<p class="note" style="text-align:left;margin:0">Elige la pieza y después ajusta cuántas quieres.</p>') +
      (lp ? '<div class="label">Piezas de precio parecido</div>' : '') +
      '<div class="grid" style="padding:0">' + cards + '</div></div></div>';
  }

  /* ---------- Render ---------- */
  function render() {
    var lines = cartLines(), t = totals(lines), app = root.querySelector('.am-app');
    if (!app) { app = document.createElement('div'); app.className = 'am-app'; root.appendChild(app); }
    /* Conserva el foco del teclado (el HTML se reemplaza en cada render) */
    var ae = document.activeElement, focusSel = null;
    if (ae && app.contains(ae)) focusSel = ae.id ? '#' + ae.id : ae.dataset && ae.dataset.a ? '[data-a="' + ae.dataset.a + '"]' : null;
    app.innerHTML = S.screen === 'cat' ? vCat(t) : S.screen === 'detail' ? vDetail(t) : S.screen === 'cart' ? vCart(t, lines) : S.screen === 'nuevo' ? vNuevo() : vHome(t);
    var target = focusSel ? app.querySelector(focusSel) : null, sheet = app.querySelector('.sheet');
    /* Cambió la pantalla y el control ya no existe: foco al primer control de la nueva (en el detalle, la ✕) */
    if (focusSel && !target) target = app.querySelector('.close, .iconbtn, .btn, [data-a]');
    /* Hoja inferior abierta: el foco entra en ella */
    if (sheet && !(target && sheet.contains(target))) target = sheet.querySelector('.iconbtn');
    if (target) target.focus({ preventScroll: true });
  }

  /* ---------- Eventos ---------- */
  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-a]');
    if (!el || !root.contains(el)) return;
    /* Toques dentro de la hoja inferior no la cierran (solo el fondo o la ✕) */
    if (el.dataset.a === 'closeswap' && e.target.closest('[data-stop]') && !e.target.closest('.iconbtn')) return;
    var parts = el.dataset.a.split(':'), a = parts[0], v = parts.slice(1).join(':');
    switch (a) {
      case 'go': if (v === 'home' || v === 'cart' || v === 'cat' || v === 'nuevo') set({ screen: v, swap: '' }); break;
      case 'biz': set({ biz: v, sugg: buildSugg(S.budget, v) }, true); break;
      case 'sinc': case 'sdec':
        var ns = S.sugg.map(function (l) { return { id: l.id, qty: l.qty }; }), si = +v;
        ns[si].qty += a === 'sinc' ? 1 : -1;
        if (ns[si].qty <= 0) ns.splice(si, 1);
        set({ sugg: ns }, true); break;
      case 'swap': set({ swap: v }, true); break;
      case 'closeswap': set({ swap: '' }, true); break;
      case 'pick':
        var s2 = S.sugg.map(function (l) { return { id: l.id, qty: l.qty }; }), pp = byId(v);
        if (S.swap === 'add') s2.push({ id: v, qty: depthOf(unitPrice(pp)) }); else s2[+S.swap] = { id: v, qty: s2[+S.swap].qty };
        set({ sugg: s2, swap: '' }, true); break;
      case 'usesugg':
        /* Pasa todo al pedido, repartido por medida */
        var c = {};
        S.sugg.forEach(function (l) {
          var sp = byId(l.id);
          if (sp) splitQty(sp, l.qty).forEach(function (x) { c[x.v.vid] = (c[x.v.vid] || 0) + x.q; });
        });
        set({ cart: c, sent: false, screen: 'cart' }); break;
      case 'cat': set({ screen: 'cat', type: v, motivo: '', simb: '' }); break;
      case 'motivo': set({ screen: 'cat', type: 'all', motivo: v, simb: '' }); break;
      case 'simb': set({ screen: 'cat', type: 'all', motivo: '', simb: v }); break;
      case 'tab': set({ type: v, motivo: '', simb: '' }); break;
      case 'chip': set({ motivo: v, simb: '', type: (S.type === 'all' && !v) ? 'pul' : S.type }); break;
      case 'sk': set({ sk: +v }, true); break;
      case 'usesurt':
        var cs = Object.assign({}, S.cart);
        surtido(S.sk).forEach(function (l) { cs[l.v.vid] = (cs[l.v.vid] || 0) + l.q; });
        set({ cart: cs, sent: false, screen: 'cart' }); break;
      case 'dj':
        var dpart = v.split(':'), dmap = Object.assign({}, S.dj);
        dmap[dpart[0]] = dpart[1];
        set({ dj: dmap }, true); break;
      case 'detail': set({ screen: 'detail', detail: v, img: 0, back: S.screen === 'cart' ? 'cart' : 'cat' }); break;
      case 'close': set({ screen: S.back || 'cat' }); break;
      case 'img': set({ img: +v }, true); break;
      case 'inc': addQty(v, 1); break;
      case 'dec': addQty(v, -1); break;
      case 'repeat':
        if (S.last && S.last.cart) {
          /* Solo piezas que siguen en el catálogo con precio de mayoreo */
          var rc = {};
          Object.keys(S.last.cart).forEach(function (vid) { if (keyOk(vid) || S.loading) rc[vid] = S.last.cart[vid]; });
          set({ cart: rc, screen: 'cart' });
        }
        break;
      case 'editship': set({ shipEdit: true }, true); break;
      case 'optin': S.optIn = el.checked; refreshSend(); break;
      case 'send':
        /* El enlace abre WhatsApp; aquí solo se guarda en el dispositivo */
        var sl = orderLines(cartLines()), t = totals(sl);
        var fol = folio();
        klaviyoSend(sl, t, fol);
        /* Evento para Meta (Lead): lo publica Shopify y lo convierte un píxel personalizado (Configuración → Eventos de clientes). 18 oct 2026 */
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('aslan_mayoreo_pedido', { folio: fol, piezas: t.count, valor: t.total, moneda: 'MXN' }); } catch (e) {}
        S.folio = null;
        var rec = { date: new Date().toLocaleDateString('es-MX', { day: 'numeric', month: 'short' }), count: t.count, sub: t.sub, cart: Object.assign({}, S.cart) };
        save(K_ULTIMO, rec); save(K_ENVIO, S.ship); save(K_CORREO, { email: S.email.trim() });
        S.last = rec; S.shipEdit = false;
        /* Se vacía el pedido: «Repetir mi último pedido» lo recupera */
        setTimeout(function () { set({ cart: {}, sent: true }); }, 50);
        break;
    }
  });
  root.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[role="button"][data-a]')) { e.preventDefault(); e.target.click(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (S.swap !== '') set({ swap: '' }, true);
      else if (S.screen === 'detail') set({ screen: S.back || 'cat' });
    }
  });
  root.addEventListener('input', function (e) {
    var f = e.target.dataset && e.target.dataset.f;
    if (!f) return;
    if (f === 'budget') {
      /* Mientras se arrastra: solo el monto y la barra (la sugerencia se recalcula al soltar) */
      S.budget = +e.target.value;
      e.target.style.setProperty('--fill', budgetFill(S.budget));
      var lbl = root.querySelector('.am-budget'); if (lbl) lbl.textContent = money(S.budget);
      return;
    }
    if (f === 'email') { S.email = e.target.value; refreshSend(); return; }
    var val = e.target.value;
    if (f === 'tel') {
      /* 10 dígitos. Si escriben o autocompletan con lada (+52 …), se acepta y se quita al completar 12 dígitos. */
      var plus = /^\s*\+/.test(val), d = val.replace(/\D/g, '');
      if (plus || (d.length > 10 && d.indexOf('52') === 0)) {
        d = d.slice(0, 12);
        val = (d.length === 12 && d.indexOf('52') === 0) ? d.slice(2) : (plus ? '+' : '') + d;
      } else {
        val = d.slice(0, 10);
      }
    }
    if (f === 'cp') val = val.replace(/\D/g, '').slice(0, 5);
    if (val !== e.target.value) e.target.value = val;
    S.ship = Object.assign({}, S.ship); S.ship[f] = val; S.shipEdit = true;
    refreshSend();
  });
  root.addEventListener('change', function (e) {
    if (e.target.dataset && e.target.dataset.f === 'budget') {
      set({ budget: +e.target.value, sugg: buildSugg(+e.target.value, S.biz) }, true);
      var r = root.querySelector('#am-budget'); if (r) r.focus({ preventScroll: true });
    }
  });
  /* Botón «atrás» del celular: regresa de pantalla en vez de salir de la página */
  window.addEventListener('popstate', function (e) {
    var st = (e.state && e.state.am) || { screen: 'home' };
    set(st, false, true);
  });
  try { history.replaceState({ am: { screen: 'home' } }, ''); } catch (e) {}

  render();
  loadRest();
})();
